import React from 'react';
import { Users, Map, CreditCard, FileBarChart2, Settings, Mail } from 'lucide-react';
import { UserRole } from 'shared-types';

export interface MenuItem {
    label: string;
    path: string;
    requiredRoles?: UserRole[];
}

export interface Menu {
    key: string;
    title: string;
    icon: React.ReactNode;
    items: MenuItem[];
    requiredRoles?: UserRole[];
}

export const menus: Menu[] = [
    {
        key: 'customers',
        title: 'לקוחות',
        icon: <Users size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'מתעניינים', path: '/leadAndCustomer/leads' },
            { label: 'לקוחות', path: '/leadAndCustomer/customers' },
            { label: 'חוזים', path: '/leadAndCustomer/contracts' },
            { label: 'לגרף מקורות', path: '/leadAndCustomer/leads/LeadSourcesPieChart' },
        ]
    },
    {
        key: 'workspace',
        title: 'חללים',
        icon: <Map size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'מפה', path: '/workspace/map' },
            { label: 'יומן הזמנות', path: '/workspace/bookingCalendar' },
            { label: 'ניהול הקצאות', path: '/workspace/assignmentTable' },
            { label: 'ניהול חדרים', path: '/workspace/rooms' },
            { label: 'ניהול חללים', path: '/workspace/management' },
            { label: 'ניהול הזמנות', path: '/workspace/bookings' }
        ]
    },
    {
        key: 'billing',
        title: 'כספים',
        icon: <CreditCard size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'חשבוניות', path: '/billing/invoice' },
            { label: 'גבייה', path: '/billing/collection' },
            { label: 'תשלומים', path: '/billing/payments' },
            { label: 'הוצאות', path: '/billing/expenses' },
            { label: 'ספקים', path: '/billing/vendor' },
            { label: 'תמחור', path: '/billing/pricing' }
        ]
    },
    {
        key: 'reports',
        title: 'דוחות',
        icon: <FileBarChart2 size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'דוח תפוסה', path: '/occupancyReports' },
            { label: 'דוח כספי', path: 'billing/financeReports' },
            // { label: 'פעילות לקוחות', path: '/customerReports' }
        ]
    },
    {
        key: 'admin',
        title: 'ניהול מערכת',
        icon: <Settings size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'משתמשים', path: '/users', requiredRoles: [UserRole.ADMIN] },
            { label: 'פעולות משתמשים', path: '/UserActions', requiredRoles: [UserRole.ADMIN] },
            // { label: 'הרשאות', path: '/permissions' },
            // { label: 'הגדרות', path: '/settings' },
            // { label: 'אינטגרציות', path: '/integrations' },
            { label: 'העלאת מסמכים', path: '/documentUpload' }
        ]
    },
    {
        key: 'communication',
        title: 'תקשורת',
        icon: <Mail size={ 18 } style={ { marginLeft: 8 } }/>,
        items: [
            { label: 'תבניות מייל', path: '/emailTemplate' },
            { label: 'תבניות מסמכים', path: '/document-templates' },
            { label: 'שליחת מיילים', path: '/sendEmails' },
            // { label: 'התראות', path: '/notifications' }
        ]
    },
];